import React from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar/Navbar';
import Banner from './components/Banner/Banner';
import GradientCard from './components/Banner/Sub-banner';
import WavyMarquee from './components/Marquee/WavyMarquee';
import ServicesGrid from './components/ServicesGrid/ServicesGrid';
import ElastiTote from './components/ElastiTote/ElastiTote';
import PrintingTech from './components/PtintingTech/PrintingTech';
import Brands from './components/Brands/Brands';
import Footer from './components/Footer/Footer';
import GranFormato from './components/GranFormato/GranFormato';
import VisualMerch from './components/VisualMerch/VisualMerch';
import BrandExperience from './components/BrandExperience/BrandExperience';
import Packaging from './components/Packaging/Packaging';
import Etiquetas from './components/Etiquetas/Etiquetas';
import Estructuras from './components/Estructuras/Estructuras';
import Nosotros from './components/Nosotros/Nosotros';
import TagPage from './components/TagPage/TagPage';
import AvisoPrivacidad from './components/AvisoPrivacidad/AvisoPrivacidad';
import Blog from './components/Blog/Blog';
import AE from './components/Blog/ProyectoEagle/ProjectDetails';
import AE2 from './components/Blog/ProyectoEagle2/ProjectDetails';
import PandoraBlog from './components/Blog/ProyectoPandora/ProjectDetails';
import ScrollToTop from './components/ScrollToTop'; 

function App() {
  return (
    <div>
      <HashRouter>
        <ScrollToTop /> {/* Agrega esto ANTES de Navbar */}
        <Navbar />
        <Main />
        <Footer />
      </HashRouter>
    </div>
  );
}

const Main = () => (
  <main>
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/gran-formato" element={<GranFormato />} />
      <Route path="/visual-merch" element={<VisualMerch />} />
      <Route path="/brand-experience" element={<BrandExperience />} />
      <Route path="/packaging" element={<Packaging />} />
      <Route path="/etiquetas" element={<Etiquetas />} />
      <Route path="/estructuras" element={<Estructuras />} />
      <Route path="/nosotros" element={<Nosotros />} />
      <Route path="/Tag" element={<TagPage />} />
      <Route path="/AvisoPrivacidad" element={<AvisoPrivacidad/>} />
      <Route path="/Blog" element={<Blog />} />
      <Route path="/AE" element={<AE/>}/>
      <Route path="/AE2" element={<AE2/>}/>
      <Route path="/pandora" element={<PandoraBlog/>}/>
      <Route path="*" element={<HomePage />} />
    </Routes>
  </main>
);

const HomePage = () => {
  return (
    <div>
      <Banner />
      <GradientCard />
      <WavyMarquee />
      <ServicesGrid />
      <ElastiTote />
      <PrintingTech />
      <Brands />
    </div>
  );
};

export default App;